<script>
import {getEmployeeSetting} from "@/api/setting-api";
import {getEmployeeByBatch, guardSearchEmployee, updateEmployee} from "@/api/organize-api";

export default {
  name: "RegisterEmployeeView",
  data() {
    return {
      employeeList: [],
      employeeSetting: {
        workId: 1,
        phoneNo: 2,
      },
      employeeDrawer: {
        show: false,
        searchType: 0,
        searchInput: "",
        employeeList: [],
      },
    }
  }, // data
  mounted() {
    getEmployeeSetting().then(({data}) => {
      console.log("getEmployeeConfigSetting", data)
      if (data.code === 200) {
        data.data.forEach(item => {
          if (item.type === "UNIVERSAL") {
            let content = JSON.parse(item.content)
            if (content) {
              this.employeeSetting.workId = content.workId
              this.employeeSetting.phoneNo = content.phoneNo
            }
          }
        })
      }
    })
  }, // mounted

  watch: {
    'employeeDrawer.searchInput': function (val) {
      this.preSearch(val)
    }
  },

  methods: {
    checkEmployeeLandline() {
      if (this.employeeList.length > 0) {
        let employee = this.employeeList[0]
        if (employee.showLandline !== employee.landline) {
          let postData = {
            id: employee.id,
            landline: employee.showLandline
          }
          updateEmployee(postData).then(({data}) => {
            console.log("updateEmployee", data)
          }).catch(err => {
            console.log("updateEmployee", err)
          })
        }
      }
    },

    // 上级调用
    doUpdateEmployee(employee) {
      this.employeeList = [employee]
      this.$set(this.employeeList[0], "showLandline", this.employeeList[0].landline)
    },

    async getEmployeeCode(employeeCode) {
      if (!employeeCode) return

      let res = await getEmployeeByBatch([employeeCode])
      if (res.data.code === 200 && res.data.data.length > 0) {
        this.employeeList = res.data.data
        this.$set(this.employeeList[0], "showLandline", this.employeeList[0].landline)
        this.notifyEmployeeChange(res.data.data[0])
      }
    },

    showAddEmployeeDrawer() {
      this.employeeDrawer = {show: true, searchInput: "", employeeList: [], searchType: 0}
    },

    notifyEmployeeChange(employee) {
      this.$emit('employeeChange', employee)
    },

    onChoiceEmployee(employee) {
      this.employeeDrawer.show = false
      this.employeeList = [employee]
      this.$set(this.employeeList[0], "showLandline", this.employeeList[0].landline)
      this.notifyEmployeeChange(employee)
    },

    preSearch(val) {
      if (this.employeeDrawer.searchType !== 0 || val === "") {
        return
      }
      this.onSearchEmployee(true)
    },

    onSearchEmployee(isAuto = false) {
      console.log("onSearchEmployee", this.employeeDrawer.searchInput)
      let search = this.employeeDrawer.searchInput
      if (!search) {
        switch (this.employeeDrawer.searchType) {
          case 0:
            this.$message.error("请输入员工姓名")
            break
          case 1:
            this.$message.error("请输入员工手机号")
            break
          case 2:
            this.$message.error("请输入员工工号")
            break
        }
        return
      }
      let searchData = {}
      switch (this.employeeDrawer.searchType) {
        case 0:
          searchData.matchName = search
          break
        case 1:
          searchData.tel = search
          break
        case 2:
          searchData.workId = search
          break
      }

      console.log("searchEmployee params", searchData)
      this.employeeDrawer.employeeList = []
      guardSearchEmployee(searchData).then(({data}) => {
        console.log("guardSearchEmployee result", data)
        if (data.code === 200) {
          if (data.data.length === 0) {
            if (isAuto !== true) {
              this.$message.warning('未找到员工');
            }
          } else {
            data.data.forEach(item => {
              this.employeeDrawer.employeeList.push(item)
            })
          }
        } else {
          if (isAuto !== true) {
            this.showServerErrMsg(data.code)
          }
        }
      }).catch(err => {
        console.log(err)
        if (isAuto !== true) {
          this.showNetErrMsg()
        }
      })
    },

    reset() {
      this.employeeList = []
      this.employeeDrawer = {show: false, searchType: 0, searchInput: "", employeeList: []}

    },

  },// methods
}
</script>

<template>
  <div>
    <el-table class="main-table" :data="employeeList" border empty-text="请添加员工">
      <el-table-column prop="name" label="员工姓名" align="center" ></el-table-column>
      <el-table-column prop="tel" label="员工手机" v-if="employeeSetting.phoneNo === 2" align="center" ></el-table-column>
      <el-table-column prop="workId" label="员工工号" v-if="employeeSetting.workId === 2" align="center" ></el-table-column>
      <el-table-column prop="departmentName" label="员工部门" align="center" ></el-table-column>
      <el-table-column prop="showLandline" label="座机号" align="center" >
        <template slot-scope="scope">
          <el-input v-model="scope.row.showLandline"></el-input>
        </template>
      </el-table-column>

    </el-table>

    <el-drawer :visible.sync="employeeDrawer.show" :with-header="false" :append-to-body="true" :close-on-click-modal="false" size="580px">
      <div class="border-b border-gray-200 h-16 p-6 flex justify-between items-center">
        <div class="font-bold text-xl">添加被访员工</div>
        <button @click="employeeDrawer.show = false" class="el-drawer__close-btn"><i class="el-icon-close"></i></button>
      </div>
      <div class="box-border h-container overscroll-y-auto">
        <el-form class="main-form w-10/12 pt-4" label-width="100px" @submit.native.prevent>
          <el-form-item label="搜索方式" prop="searchType">
            <el-radio-group v-model="employeeDrawer.searchType">
              <el-radio :label="0">姓名</el-radio>
              <el-radio :label="1" v-if="employeeSetting.phoneNo === 2">手机号</el-radio>
              <el-radio :label="2" v-if="employeeSetting.workId === 2">工号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="搜索员工" v-if="employeeDrawer.searchType === 0">
            <el-input v-model="employeeDrawer.searchInput" placeholder="请输入员工姓名">
              <el-button slot="append" icon="el-icon-search" @click="onSearchEmployee"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="搜索员工" v-else-if="employeeDrawer.searchType === 1">
            <el-input v-model="employeeDrawer.searchInput" placeholder="请输入员工手机号">
              <el-button slot="append" icon="el-icon-search" @click="onSearchEmployee"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="搜索员工" v-else>
            <el-input v-model="employeeDrawer.searchInput" placeholder="请输入员工工号">
              <el-button slot="append" icon="el-icon-search" @click="onSearchEmployee"></el-button>
            </el-input>
          </el-form-item>

        </el-form>

        <el-table class="main-table px-4" :data="employeeDrawer.employeeList" empty-text="暂无员工" border v-if="employeeDrawer.employeeList.length >0">
          <el-table-column prop="name" label="员工姓名"></el-table-column>
          <el-table-column prop="departmentName" label="员工部门"></el-table-column>
          <el-table-column prop="workId" label="员工工号" v-if="employeeSetting.workId === 2"></el-table-column>
          <el-table-column prop="tel" label="员工手机" v-if="employeeSetting.phoneNo === 2"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="{row}">
              <el-button  type="success" @click="onChoiceEmployee(row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="border-t border-gray-200 h-16 p-6 flex justify-center items-center">
        <el-button @click="employeeDrawer.show = false">取消</el-button>
      </div>
    </el-drawer>

  </div>
</template>

<style scoped lang="less">
.main-table{
  font-size: 20px;

  .el-input{
    font-size: 20px;

  }
}

.el-form {
  font-size: 20px;
}

.main-form {
  /deep/ .el-form-item__label {
    font-size: 20px;
  }
  .el-radio {
    height: 42px;
    line-height: 42px;
  }
  /deep/ .el-radio__label {
    font-size: 20px;
  }

  .el-select {
    width: 100%;
  }
  /deep/ .el-input__inner{
    font-size: 20px;

  }
}
/deep/ .el-table thead {
  font-size: 20px;
  color: #606266;
  font-weight: 400;
}
</style>
